import { css } from 'styled-components'

export const hiddenScrollbarCss = css`
  /* Remove scrollbar from layout (Windows classic gutter ≈16px); webkit-only hide is not enough everywhere */
  scrollbar-width: none;
  -ms-overflow-style: none;
  scrollbar-color: transparent transparent;

  &::-webkit-scrollbar {
    display: none; // Safari and Chrome
  }
`
